<template>
  <el-autocomplete
          @focus="inputFocus"
          class="inline-input"
          v-model="model"
          :fetch-suggestions="querySearch"
          :placeholder="placeholder"
          @select="handleSelect"
  ></el-autocomplete>
</template>

<script>
  import {SkuLabelValue} from "../../../network/skuInfo";

  export default {
    name: "SelectInput",
    props:{
      itemArr:Array,
      value:String,
      placeholder:String
    },
    data(){
      return{

      }
    },
    computed: {
      model: {
        get(){
          return this.value
        },
        set(value){
          let item = {}
          item.value = value
          // this.$emit("handleSelect",item)
        }
      }
    },
    methods:{
      querySearch(queryString, cb) {
        let itemArr = this.itemArr;
        let results = queryString ? itemArr.filter(this.createFilter(queryString)) : itemArr;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (itemArr) => {
          return (itemArr.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        this.$emit("handleSelect",item)
      },
      inputFocus(){
        this.$emit("inputFocus")
      }
    }
  }
</script>

<style scoped>

</style>
